import { FooterComponent } from './../footer/footer.component';
import { Component, OnInit, OnDestroy, HostListener, AfterViewInit } from '@angular/core';
import { Angulartics2 } from 'angulartics2';
import 'hammerjs';
import * as $ from 'jquery';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})

export class MainComponent implements OnInit, OnDestroy, AfterViewInit {

  showTobias = true;
  private fragment: string;

  slideConfig = {
    autoplay: true,
    pauseOnHover: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinte: true,
    dots: false,
    arrows: true,
  };

  slideConfigSmall = {
    autoplay: true,
    pauseOnHover: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinte: true,
    dots: true,
    arrows: false,
  };

  slides = [
    {img: './assets/images/team/david-carousel.png'},
    {img: './assets/images/team/telfer-carousel.png'},
    {img: './assets/images/team/andrew-carousel.png'},
    {img: './assets/images/team/chirage-carousel.png'},
    {img: './assets/images/team/Ryan_carousel_new.jpg'},
    {img: './assets/images/team/cassie-carousel.png'},
    /* {img: './assets/images/team/florian-carousel.png'}, */
    {img: './assets/images/team/elias-carousel-fixed.png'},
    {img: './assets/images/team/terri-carousel.png'},
    {img: './assets/images/team/lynn-carousel.png'},
    {img: './assets/images/team/monica-carousel.jpg'},
    {img: './assets/images/team/alyssa-carousel.png'},
    {img: './assets/images/team/axel-carousel.png'},
  ];

  // --> HEADER RESIZE LOGIC <-- //
  @HostListener('window:resize', ['$event'])
  onResize() {
    if (window.innerWidth >= 720) {
      this.showTobias = true;
    } else {
      this.showTobias = false;
    }
  }

  constructor(public angulartics2: Angulartics2,
              private route: ActivatedRoute) {

  }

  ngOnInit() {
    this.route.fragment.subscribe(fragment => {
      this.fragment = fragment;
    });
    if (this.angulartics2) {
      this.angulartics2.eventTrack.next({
        action: 'page-view-main'
      });
      console.log(this.angulartics2);
    }
  }

  ngAfterViewInit(): void {
    if (window.innerWidth >= 720) {
      this.showTobias = true;
    } else {
      this.showTobias = false;
    }
    try {
      $('html, body').animate({scrollTop: $('#' + this.fragment).offset().top}, {duration: 1});
      if (this.route.snapshot.url[0].path.includes('contact')) {
        $('#under-bar').css({'opacity': 1});
        $('#under-bar').animate({'margin-left': '469px'});
      } else {
        $('#under-bar').css({'opacity': 0});
      }
    } catch (e) {
      // console.log(e);
    }
    if (window.innerWidth >= 1195) {
      $('#about-link').removeClass('grey-text');
      $('#brands-link').removeClass('grey-text');
      $('#team-link').removeClass('grey-text');
      $('#investors-link').removeClass('grey-text');
      $('#contact-link').removeClass('grey-text');
    }
    $('.nav-link').css('color', '#fff');
  }


  ngOnDestroy() {

  }

  toContact() {
    $('html, body').animate({scrollTop: $('#contact').offset().top}, 'medium');
    if (this.angulartics2) {
      this.angulartics2.eventTrack.next({
        action: 'section-view-contact'
      });
      console.log(this.angulartics2);
    }
  }

  gotoAbout() {
    try {
      $('html, body').scrollTop(0);
      $('#under-bar').css({'opacity': 1});
      $('#under-bar').animate({'margin-left': '36px'});
      if (window.innerWidth <= 1194) {
        const mobileAbout = document.getElementById('mobile-about');
        mobileAbout.classList.add('opac');
        const mobileBrands = document.getElementById('mobile-brands');
        mobileBrands.classList.remove('opac');
        const mobileTeam = document.getElementById('mobile-team');
        mobileTeam.classList.remove('opac');
        const mobileInvestors = document.getElementById('mobile-investors');
        mobileInvestors.classList.remove('opac');
        const mobileContact = document.getElementById('mobile-contact');
        mobileContact.classList.remove('opac');
      }
    } catch (e) {
      // console.log(e);
    }
  }

  goInvestors() {
    if (window.innerWidth <= 1194) {
      const mobileAbout = document.getElementById('mobile-about');
      mobileAbout.classList.remove('opac');
      const mobileBrands = document.getElementById('mobile-brands');
      mobileBrands.classList.remove('opac');
      const mobileTeam = document.getElementById('mobile-team');
      mobileTeam.classList.remove('opac');
      const mobileInvestors = document.getElementById('mobile-investors');
      mobileInvestors.classList.add('opac');
      const mobileContact = document.getElementById('mobile-contact');
      mobileContact.classList.remove('opac');
    }
  }

  externalLink() {
    // window.open('https://www.amazon.com/stores/Dr-Tobias/node/8971601011', '_blank');
    if (this.angulartics2) {
      this.angulartics2.eventTrack.next({
        action: 'tobias-external-link'
      });
      console.log(this.angulartics2);
    }
  }

}
